import React from 'react';
import styled from 'styled-components';

import Loader from './Loader';

export const FixedLoader = ({ size, color }: FixedLoaderProps) => (
	<FixedLoaderWrapper>
		<Loader size={size} color={color} />
	</FixedLoaderWrapper>
);

export default FixedLoader;

export interface FixedLoaderProps {
	size?: number;
	color?: string;
}

const FixedLoaderWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 50;
`;
